import { Reducer } from "react";

import { Flow } from '../../service/flowengine/FlowEngineAPI';
import { Page } from '../../service/flowengine/model/Page';

//import { Flow } from '../../service/flowengine/';

// ----------------------------------------------------------
// FlowInput
export type FlowState = {
    //flow: any,
    flow: Flow,
}

const initialFlowInputState: FlowState = {
    flow: {
        name: "unknown",
        label: "unknown",
        Pages: [],
    }
}

type UpdateFlowAction = {
    type: String,
    payload: FlowState
}

export function updateFlowInputAction(payload: FlowState) {
    return { type: "DO_UPDATE_INPUT", payload: payload }
};

const flowInputReducer : Reducer<FlowState, UpdateFlowAction> = (state: FlowState = initialFlowInputState, action: UpdateFlowAction | any) => {
    switch(action.type) {
        case 'DO_UPDATE_INPUT':  // update redux with input data (e.g. we changed an input value)
            return {
                // nice description of "destructuring syntax", "Rest operator" and "Spread operator": https://mariusschulz.com/blog/object-rest-and-spread-in-typescript
                // article is also saved in "documentation" subdirectory of this project
                ...state, flow: {...state.flow, ...action.payload.flow }  // spread/rest operator "...": take "state" and add the rest of type by setting member "flowInput" explicitely
            };
        default: 
            return state;
    }
}

export default flowInputReducer;

